import { AiMatchingRouteGate } from "../components/AiMatchingRouteGate";
import { MentorProfileLegacy } from "./legacy/MentorProfileLegacy";
import { MentorProfilePreview } from "./MentorProfilePreview";

export const MentorProfile = () => (
  <AiMatchingRouteGate preview={<MentorProfilePreview />} legacy={<MentorProfileLegacy />} />
);
